import * as Yup from 'yup'
import {
  awsAccountIdFieldValidationMessage,
  casS3ValidationMessage,
  casSNSTopicValidationMessage,
  iamArnValidationMessage,
  kmsKeyArnValidationMessage,
  s3ArnisMandatoryWhenOtherFieldsArepresent,
  kmsKeyArnisMandatoryWhenOtherFieldsArepresent,
  snsTopicArnisMandatoryWhenOtherFieldsArepresent,
  mandatoryFieldMessage,
  terraformConnectionValidationMandatoryMessage,
  awsRegexValidationMessage,
} from './messagesContants'
import {
  IamArnRegex,
  awsAccountIdRegex,
  awsCasS3BucketNameRegex,
  emptySpaceCharsAtStartAndEndRegex,
  kmsKeyArnRegex,
  snsTopicARNPattern,
} from './constants'
import { isEmpty } from 'lodash'

export const getFlyoutCloudSettingsValidateSchema = (
  isMarketplaceCloudSettingsRevampEnabled = false,
  isOnboardingImprovementsEnabled = false
) =>
  Yup.object().shape({
    //add validation here
    awsAccountId: Yup.string()
      .required(mandatoryFieldMessage)
      .matches(emptySpaceCharsAtStartAndEndRegex, `${mandatoryFieldMessage}.`)
      .min(12, awsAccountIdFieldValidationMessage)
      .max(12, awsAccountIdFieldValidationMessage)
      .matches(awsAccountIdRegex, awsRegexValidationMessage),
    awsAccountName: Yup.string()
      .matches(emptySpaceCharsAtStartAndEndRegex, `${mandatoryFieldMessage}.`)
      .required(mandatoryFieldMessage),
    sellerType: Yup.array()
      .min(1, 'At least one seller type is required.')
      .required('This field is required.'),
    sellerMetadata: Yup.object().shape({
      awsRoleArn: Yup.string()
        .matches(emptySpaceCharsAtStartAndEndRegex, `${mandatoryFieldMessage}.`)
        .matches(IamArnRegex, iamArnValidationMessage)
        .required(mandatoryFieldMessage),

      awsCasS3BucketName: isMarketplaceCloudSettingsRevampEnabled
        ? Yup.string()
            .matches(
              emptySpaceCharsAtStartAndEndRegex,
              `${mandatoryFieldMessage}.`
            )
            .required(s3ArnisMandatoryWhenOtherFieldsArepresent)
            .matches(awsCasS3BucketNameRegex, casS3ValidationMessage)
        : Yup.string()
            .matches(
              emptySpaceCharsAtStartAndEndRegex,
              `${mandatoryFieldMessage}.`
            )
            .matches(awsCasS3BucketNameRegex, casS3ValidationMessage)
            .test(
              'validateS3Bucket',
              s3ArnisMandatoryWhenOtherFieldsArepresent,
              (value, context) => {
                if (!isEmpty(value)) {
                  return true
                } else {
                  if (
                    !isEmpty(
                      context.options.context?.sellerMetadata?.awsCasSnsTopic
                    ) ||
                    !isEmpty(
                      context.options.context?.sellerMetadata?.awsKmsKeyArn
                    )
                  ) {
                    return false
                  }
                  return true
                }
              }
            ),
      awsKmsKeyArn: isMarketplaceCloudSettingsRevampEnabled
        ? Yup.string()
            .matches(
              emptySpaceCharsAtStartAndEndRegex,
              `${mandatoryFieldMessage}.`
            )
            .required(kmsKeyArnisMandatoryWhenOtherFieldsArepresent)
            .matches(kmsKeyArnRegex, kmsKeyArnValidationMessage)
        : Yup.string()
            .matches(kmsKeyArnRegex, kmsKeyArnValidationMessage)
            .test(
              'validateKmsKeyArn',
              kmsKeyArnisMandatoryWhenOtherFieldsArepresent,
              (value, context) => {
                if (!isEmpty(value)) {
                  return true
                } else {
                  if (
                    !isEmpty(
                      context.options.context?.sellerMetadata
                        ?.awsCasS3BucketName
                    ) ||
                    !isEmpty(
                      context.options.context?.sellerMetadata?.awsCasSnsTopic
                    )
                  ) {
                    return false
                  }
                  return true
                }
              }
            ),
      awsCasSnsTopic: isMarketplaceCloudSettingsRevampEnabled
        ? Yup.string()
            .matches(
              emptySpaceCharsAtStartAndEndRegex,
              `${mandatoryFieldMessage}.`
            )
            .required(snsTopicArnisMandatoryWhenOtherFieldsArepresent)
            .matches(snsTopicARNPattern, casSNSTopicValidationMessage)
        : Yup.string()
            .matches(snsTopicARNPattern, casSNSTopicValidationMessage)
            .test(
              'validateCasSnsTopic',
              snsTopicArnisMandatoryWhenOtherFieldsArepresent,
              (value, context) => {
                if (!isEmpty(value)) {
                  return true
                } else {
                  if (
                    !isEmpty(
                      context.options.context?.sellerMetadata
                        ?.awsCasS3BucketName
                    ) ||
                    !isEmpty(
                      context.options.context?.sellerMetadata?.awsKmsKeyArn
                    )
                  ) {
                    return false
                  }
                  return true
                }
              }
            ),
    }),
    countryRegistered: Yup.string().required('Country is required'),
    isOwnS3Bucket: Yup.boolean().optional(),
    stackType: Yup.string().oneOf(['cloudformation', 'terraform']).optional(),
    terraformConnectionValidated: Yup.boolean().test(
      'terraform-connection-validated',
      terraformConnectionValidationMandatoryMessage,
      function (value) {
        if (
          this.parent.stackType !== 'terraform' ||
          !isOnboardingImprovementsEnabled
        ) {
          return true
        }
        return value === true
      }
    ),
  })

const flyoutCloudSettingsValidateSchema = getFlyoutCloudSettingsValidateSchema()
export default flyoutCloudSettingsValidateSchema
